import { createApp } from 'vue';
import { auth } from './utils/firebaseConfig.js';
import App from './App.vue';
import router from './router/index.js' 
import store from './utils/store.js';
import i18n from './i18n.js';
import './assets/styles/base.css'
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

let app;

auth.onAuthStateChanged(() => {
  if (!app) {
    app = createApp(App)
      .use(router)
      .use(store)
      .use(i18n)
      .use(VCalendar, {})
      .mount('#app');
  }
  
  store.dispatch('checkUser');
});
